import { render } from "./BlackScreenMod.vue?vue&type=template&id=5a53c421&scoped=true"
import script from "./BlackScreenMod.vue?vue&type=script&lang=js"
export * from "./BlackScreenMod.vue?vue&type=script&lang=js"

import "./BlackScreenMod.vue?vue&type=style&index=0&id=5a53c421&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a53c421"]])

export default __exports__